import { BackgroundColorField } from './types';

// TODO: unit test to check what will return empty string value
export const getBackgroundStyle = (field?: BackgroundColorField) => ({
  backgroundColor: field?.fields?.ColorCode?.value
});

export const isBlack = (field?: BackgroundColorField) => field?.fields?.ColorCode?.value === '#000';
